export default __webpack_public_path__ + "static/media/avatar_brown_bear1.5aca88d6.mp3";